const ALL_ACCESS_PASS = /^\s*ALL\s+ACCESS\s+PASS[.\s]*$/i;
const GROUP_PASS = /GROUP/i;
const DISCOUNT_AMOUNT = 'amount';

export const getCostWithDiscount = (cost, discountType, discountValue) => {
  if (!discountValue) return cost;

  const costWithDiscount =
    discountType === DISCOUNT_AMOUNT
      ? cost - discountValue
      : cost - cost * (discountValue / 100);

  return Math.round(costWithDiscount * 100) / 100;
};

export const getBundleDynamicPriceProduct = (inventory) => {
  if (!inventory?.length) return;

  return inventory.find((product) => {
    if (!product?.name) return false;

    return (
      ALL_ACCESS_PASS.test(product.name.trim().replace(/\s+/g, ' ')) &&
      !GROUP_PASS.test(product.name.toUpperCase())
    );
  });
};

export const getBundleAmount = (tickets) => {
  if (!tickets || !tickets.length)
    return {
      totalAmountWithoutTaxes: 0,
      totalAmount: 0,
      totalTaxes: 0,
    };

  const amount = tickets.reduce(
    (amount, ticket) => {
      const { cost = 0, tax = 0 } = ticket;

      const taxAmount = cost * (tax / 100);

      amount.totalAmountWithoutTaxes += cost;
      amount.totalTaxes += taxAmount;
      amount.totalAmount += cost + taxAmount;

      return amount;
    },
    {
      totalAmountWithoutTaxes: 0,
      totalAmount: 0,
      totalTaxes: 0,
    }
  );

  return {
    totalAmountWithoutTaxes: Number(amount.totalAmountWithoutTaxes.toFixed(2)),
    totalAmount: Number(amount.totalAmount.toFixed(2)),
    totalTaxes: Number(amount.totalTaxes.toFixed(2)),
  };
};
